<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <bar-card class="lefts" :bg="'border2'">
          <v-title>各类项目占比情况</v-title>
          <div class="panelContent">
            <right-top />
          </div>
        </bar-card>
        <bar-card class="lefts lefts2" :bg="'border2'">
          <v-title>建设项目</v-title>
          <div class="panelContent">
            <right-bot />
          </div>
        </bar-card>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import rightTop from "./rightBar/rightTop";
import rightBot from "./rightBar/rightBot";
export default {
  components: { rightTop, rightBot },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.panelContent
  height calc(100% - 43px)
  color #fff
.lefts
  height 40%
  margin-bottom 10px
.lefts2
    height calc(60% - 10px)
@media (min-height 1400px)
  .rightBar
    >>>.side
      width 24% !important
</style>
